import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

// interfaces
import { ICategory } from 'src/app/core/interfaces/category/category';

// services
import { TopLevelSingleService } from 'src/app/core/services/single-api-top-level-app/singel-top-level.service';

export const categoriesResolver: ResolveFn<Observable<ICategory[]>> = (route, state) => {
  
  const singleTop = inject(TopLevelSingleService)

  return singleTop.Categories$;
};
